module.exports = __webpack_public_path__ + "img/Loading.2db3cbf7.png";